import { Separator } from '../../components/separator'
import { TextSubheader } from '../../components/text/text-subheader'
import ApplicationCooLayout from '../../layout/application-coo-layout'
import { SectionCard } from '../../components/card'
import { P2Button, P2ButtonGroup, P2TextDescription, P2Alert } from 'react-bootstrap-common-script'
import ReviewEligibility from '../application-coo/review-endorse/eligibility'
import ReviewFinancing from '../application-coo/review-endorse/financing'
import { LoanTypeEnum } from '../../models/enum/loan-type.enum'
import { useCallback, useEffect, useMemo, useState } from 'react'
import ReviewConveyancing from '../application-coo/review-endorse/conveyancing'
import { useForm } from '../../hooks/use-form'
import { StageBConveyancing, StageBDocumentation, StageBPersonalDetail, StageBReviewEndorse } from '../../models/classes/stage-b/review-endorse.class'
import ReviewHouseholdStructureTable from '../application-coo/review-endorse/review-household-structure-table'
import { Owner } from '../../models/polymer/Owner.model'
import { LegalRepresentation, TenancyInCommon } from '../../models/classes/ApplicationStep3.class'
import { MyInfo } from '../../models/polymer/MyInfo.model'
import { useAppSelector } from '../../redux/hook'
import ReviewPersonalDetails from './review-endorse/review-personal-details'
import { StructureStatusEnum } from '../../models/enum/structure-status.enum'
import { validateStageBFinancing } from '../../utils/validators/stage-b/financial-validator'
import { validateStageBConveyancing } from '../../utils/validators/stage-b/conveyancing-validator'
import { validateStageBPersonalDetail } from '../../utils/validators/stage-b/personal-detail-validator'
import { validateStageBReviewEndorse } from '../../utils/validators/stage-b/review-validator'
import { useNavigate } from 'react-router-dom'
import { ChangeOwnershipReasonCode } from '../../utils/code-converter'
import { ApplicationStep2 } from '../../models/classes/ApplicationStep2.class'
import { CooGiveConsent } from '../../models/classes/CooGiveConsent.class'
import { PolymerAxios } from '../../utils/axios'
import { API_CheckApplicationConsent, API_CheckEligibility, API_DocumentSave,API_EligibilityDebugLog, API_GiveConsent, API_MOPCheck, API_OverrideEligibilityCheck } from '../../utils/api'
import { SubmitFinancing } from '../../models/classes/CooSubmission.class'
import Declaration from '../application-coo/review-endorse/declaration'
import { HoldingTypeEnum } from '../../models/enum/holding-type.enum'
import ContactDetails from './review-endorse/contact-detail'
import { checkIsFlatResale, checkNeedBypass35YearsOld, convertRaceToEthnicCode, convertRoleToStructureStatus, step1SchemeCheckingEligibility } from '../../utils/form-helper'
import { useWindowScrollTo } from '../../hooks/use-initial-window-scroll-to'
import { Eligibility } from '../../models/polymer/Eligibility.model'
import { Occupier } from '../../models/polymer/Occupier.model'
import { cloneDeep } from 'lodash'
import config from '../../config'
import { SexEnum } from '../../models/enum/sex.enum'
import { usePrepareDocuments } from '../../hooks/use-prepare-documents'
import { SolicitorTypeEnum } from '../../models/enum/solicitor-type.enum'
import useCheckRemission from '../../hooks/use-check-remission'
import useCheckLoginIsAdditionalRole from '../../hooks/use-check-login-role'
import { PolymerCrypto } from '../../utils/encryptor'
import { ApplicationStep1 } from '../../models/classes/ApplicationStep1.class'
import { ConsentApplication } from '../../models/polymer/ConsentApplication.model'
import { MopCheckStatusEnum } from '../../models/enum/mop-check-status.enum'
import { stageBTrackingId } from "../../utils/wogaa-ids";
import { customWindow } from "../../models/interfaces/wogaa.interface";
import { EligibilityCheck, EligibilityOverride } from '../../models/classes/EligibilityOverride.class'
import useGetEligibilityOverride from '../../hooks/use-get-eligibility-override'
import { MaritalStatusEnum } from '../../models/enum/marital-status.enum'
import { StampDutyValuationEnum } from '../../models/enum/stamp-duty-valuation.enum'

interface MainApplicantFilledData {
  my_info?: MyInfo,
  is_related?: boolean,
  relationship_with_owner?: string,
}

interface ForceErrors { 
  financing: boolean,
  conveyancing: boolean,
  personalDetails: boolean,
  documents: boolean,
  declaration: boolean
}

function OthersReview() {

  const navigate = useNavigate();

  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get("application_id");

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const applicationStep1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const applicationStep2FormData = useAppSelector(state => state.app.ApplicationStep2Slice.formData);
  const applicationStep3FormData = useAppSelector(state => state.app.ApplicationStep3Slice.formData);
  const { documentList, updateLastWillIsChecked, processStageBDocumentation, processDocumentsForOutgoingOwners } = usePrepareDocuments("B");
  const { bypassSolicitors, bypassPayments } = useGetEligibilityOverride(applicationStartFormData.selected_hdb_property?.hdb_ref);
  
  const myInfoData = useAppSelector(state => state.auth.AuthenticationSlice.myInfoData);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const retrieveFromMyInfo = useAppSelector(state => state.auth.AuthenticationSlice.retrieveFromMyInfo);
  const currentHoldingType = useAppSelector(state => state.app.ApplicationStartSlice.formData.selected_hdb_property?.holding_type);
  const applicationId = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const [isDobMatch, setIsDobMatch] = useState<boolean>(true);
  const [isMaritalStatusMatch, setIsMaritalStatusMatch] = useState<boolean>(true);
  const [isSpouseIdMatch, setIsSpouseIdMatch] = useState<boolean>(true);
  const [isEligible, setIsEligible ] = useState<boolean>(true);
  const [ineligibleMessage, setIneligibleMessage] = useState<any>(<></>);
  const [isProposedConsented, setIsProposedConsented] = useState<boolean>(false);
  const [mopResult, setMopResult] = useState<MopCheckStatusEnum | undefined>(undefined);
  const [mainApplicantFilledData, setMainApplicantFilledData] = useState<MainApplicantFilledData>({my_info: undefined, is_related: undefined, relationship_with_owner: undefined})
  const [isHLEApprovalPass, setIsHLEApprovalPass] = useState<boolean | undefined>(undefined);
  const [ forceErrors, setForceErrors ] = useState<ForceErrors>({financing: false, conveyancing: false, personalDetails: false, documents: false, declaration: false});
  const { values, formValid, setFormValue, setAdditionalData } = useForm(new StageBReviewEndorse(), () => { }, validateStageBReviewEndorse); //DONE
  const { result: isMainApplicantCreateApplication } = useCheckLoginIsAdditionalRole()
  
  const { values:financialFormValues, errors:financialFormErrors, formValid:financialFormValid, setFormValue:SetFinancialFormValue, setAdditionalData:SetFinancialAdditionData }:{values: ApplicationStep2, errors:any, formValid:boolean, setFormValue: (update: any) => void, setAdditionalData: (additional_data: any) => void} = useForm(new ApplicationStep2(), () => { }, validateStageBFinancing);
  const { values:conveyancingValues, errors:conveyancingErrors, formValid:conveyancingValid, setFormValue:SetConveyancingValue, setAdditionalData:SetConveyancingAdditionData }:{values: StageBConveyancing, errors:any, formValid:boolean, setFormValue: (update: any) => void, setAdditionalData: (additional_data: any) => void} = useForm(new StageBConveyancing(), () => { }, validateStageBConveyancing);
  const { values:personalDetailValues, errors:personalDetailErrors, formValid:personalDetailValid, setFormValue:SetPersonalDetailValue, setAdditionalData:SetPersonalDetailAdditionData }:{values: StageBPersonalDetail, errors:any, formValid:boolean, setFormValue: (update: any) => void, setAdditionalData: (additional_data: any) => void} = useForm(new StageBPersonalDetail(), () => { }, validateStageBPersonalDetail);
  const { values:documentationValues, setFormValue:SetDocumentationValue }:{values: StageBDocumentation, errors:any, formValid:boolean, setFormValue: (update: any) => void, setAdditionalData: (additional_data: any) => void} = useForm(new StageBDocumentation(), () => { }, ()=>{});

  const {toScroll} = useWindowScrollTo();

  useEffect(() =>{
    console.log("start form data:", applicationStartFormData);
  }, [applicationStartFormData])


  const { isRemission, displayValuation, setNewLoanType } = useCheckRemission(applicationStartFormData, applicationStep1FormData, applicationStep2FormData, conveyancingValues);
    
  const fetchConsentedOwners = async () => {
    try {
      const response = await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).get(`${API_CheckApplicationConsent}?applicationUuid=${applicationId}`);
      const data:ConsentApplication = response.data;
      console.log(data)
      const proposedOwnersUinfins = applicationStep1FormData.household.incoming_owners.map(item => item.myinfo.uinfin);
      const consentedProposedOwners = data.owners_consent_status.filter(
        (item) =>
          proposedOwnersUinfins.includes(PolymerCrypto.decryption(item.uin_fin))
          && item.consent_given === true
      );
      if(isMainOutgoing){
        setIsProposedConsented(consentedProposedOwners.length > 0); 
      }else{
        setIsProposedConsented(true);
      }
    } catch (error) {
      console.error("Error fetching consented owners:", error);
    }
  };

  useEffect(() => {
    fetchConsentedOwners();
  }, [])

  useEffect(() => {
    if(!application_id || application_id == "undefined" || application_id !== applicationId){
      window.location.href = "/transfer/dashboard";
    }
  }, [application_id])

  useEffect(() => {
    if(!applicationStartFormData?.selected_hdb_property?.hdb_ref) {
      window.location.href = "/transfer/dashboard";
    }
  }, [applicationStartFormData])

  const differentOutgoingOwnerSolicitorNotSelected = useMemo(() => {
    return !applicationStep3FormData.outgoing_solicitor_type;
  }, [applicationStep3FormData])

  useEffect(() => {
    //To clear documents upon deselecting outgoing different solicitor/switch to hdb solicitor
    if(isLoginOutgoing && (!conveyancingValues.outgoing_solicitor_type || conveyancingValues.outgoing_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor)){
      SetDocumentationValue({file_items: []})
    }
  }, [conveyancingValues.outgoing_solicitor_type])

  const isCurrentDirectConveyancing = useMemo(()=>{
    return financialFormValues.current_loan_type === LoanTypeEnum.no_loan;
  },[financialFormValues.current_loan_type])

  const isProposedDirectConveyancing = useMemo(()=>{
    return financialFormValues.new_loan_type === LoanTypeEnum.no_loan
  },[financialFormValues.new_loan_type])

  useEffect(() => {
      setNewLoanType(financialFormValues.new_loan_type);
  }, [financialFormValues])


  /**
   * @description to check if current login user is main applicant.
   */
  const isMainApplicant = useMemo(()=>{
    
    if(loginUser.uinfin === applicationStartFormData.selected_hdb_property?.main_applicant_uinfin){
      return true;
    }
    else{
      return false;
    }
    
  },[applicationStartFormData, loginUser])


  /**
   * @description to check if main applicant is outgoing or retaining
   */
  const {isMainRetaining, isMainOutgoing} = useMemo(()=>{
    
    const main_applicant_uinfin = applicationStartFormData.selected_hdb_property?.main_applicant_uinfin;
    if(!main_applicant_uinfin){
      console.log("STAGE B -> NO MAIN APPLICANT UINFIN");
      return {isMainRetaining:false, isMainOutgoing:false}
    }
    
    let isMainRetaining = applicationStep1FormData.household.incoming_owners.some(e=>e.myinfo.uinfin === main_applicant_uinfin);
    return {isMainRetaining:isMainRetaining, isMainOutgoing:!isMainRetaining}
    
  },[ applicationStartFormData, applicationStep1FormData ]);
  


  /**
   * @description to check if login user is outgoing or retaining
   */
  const { isLoginRetaining, isLoginOutgoing, isLoginIncoming } = useMemo(() => {
    const ownerInfoInCurrentHousehold = applicationStep1FormData.household.owners.find(e => e.myinfo.uinfin === loginUser.uinfin);
    const ownerInfoInProposedHousehold = applicationStep1FormData.household.incoming_owners.find(e => e.myinfo.uinfin === loginUser.uinfin);

    return {
      isLoginRetaining:
        !!ownerInfoInCurrentHousehold && !!ownerInfoInProposedHousehold && ownerInfoInProposedHousehold.structure_status === StructureStatusEnum.retaining,
      isLoginOutgoing:
        !!ownerInfoInCurrentHousehold && !ownerInfoInProposedHousehold && ownerInfoInCurrentHousehold.structure_status === StructureStatusEnum.outgoing,
      isLoginIncoming:
        !ownerInfoInCurrentHousehold && !!ownerInfoInProposedHousehold && ownerInfoInProposedHousehold.structure_status === StructureStatusEnum.incoming,
    };
  },[applicationStep1FormData, loginUser]);


  const currentConveyancingUEN = useMemo(()=>{
    let uen = "";
    if((conveyancingValues.current_solicitor_type === SolicitorTypeEnum.private_solicitor || conveyancingValues.current_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor)){
      uen = conveyancingValues.current.conveyancing_private_solicitor.uen ? conveyancingValues.current.conveyancing_private_solicitor.uen : conveyancingValues.current.private_solicitor.uen;
    }
    return uen;
  },[conveyancingValues])
  
  const proposedConveyancingUEN = useMemo(()=>{
    let uen = "";
    if((conveyancingValues.proposed_solicitor_type === SolicitorTypeEnum.private_solicitor || conveyancingValues.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor)){
      if(conveyancingValues.proposed.private_solicitor.is_confirm){
        if(conveyancingValues.proposed.private_solicitor.represented_same_solicitor){
          uen = conveyancingValues.proposed.private_solicitor.uen;
        }
      }
      if(conveyancingValues.proposed.conveyancing_private_solicitor.is_confirm){
          uen = conveyancingValues.proposed.conveyancing_private_solicitor.uen;
      }
    }
    return uen;

  },[conveyancingValues.proposed.conveyancing_private_solicitor.is_confirm, conveyancingValues.proposed.conveyancing_private_solicitor.uen, conveyancingValues.proposed.private_solicitor.is_confirm, conveyancingValues.proposed.private_solicitor.represented_same_solicitor, conveyancingValues.proposed.private_solicitor.uen, conveyancingValues.proposed_solicitor_type])

  const isProposedSolicitorConveyancingSameAsCurrent = useMemo(()=>{
    console.log("isProposedSolicitorConveyancingSameAsCurrent",JSON.stringify(currentConveyancingUEN), JSON.stringify(proposedConveyancingUEN));
    return JSON.stringify(currentConveyancingUEN.toString()) === JSON.stringify(proposedConveyancingUEN.toString());
  },[currentConveyancingUEN, proposedConveyancingUEN])

  const spouseCheck = (encryptedOwnersAndOccupiers: (Owner | Occupier)[]) => {
    // Check for mismatched spouse uinfin is done in stage A
    const {myinfo: {sex}, spouse} = personalDetailValues.login_user;

    if (sex === SexEnum.unknown || !spouse) {
      return { eligible: true, message: "Passed due to missing gender or spouse id" }
    };

    for (const currentPerson of encryptedOwnersAndOccupiers) {
      const decryptedUinfin = PolymerCrypto.decryption(currentPerson.myinfo.uinfin);
      const isSpouse = spouse === decryptedUinfin;

      if (!isSpouse || currentPerson.myinfo.sex === SexEnum.unknown || !currentPerson.spouse) continue;

      const invalidGenderPair =
        (personalDetailValues.login_user.myinfo.sex === SexEnum.male && currentPerson.myinfo.sex === SexEnum.male) ||
        (personalDetailValues.login_user.myinfo.sex === SexEnum.female && currentPerson.myinfo.sex === SexEnum.female);

      if (invalidGenderPair) {
        return { eligible: false, message: "Spouse information is invalid." };
      }
    }

    return { eligible: true, message: "Passed all checks" };
  };

  const requireReview = useMemo(() => {
    if(applicationStep2FormData.new_loan_type || applicationStep3FormData.proposed_solicitor_type) {
      return false;
    }
    
    if(isMainOutgoing){
        if(isProposedConsented){
          return false;
        }
    }else{
        return false;
    }
    
    return true;
}, [isMainOutgoing, isProposedConsented, applicationStep2FormData, applicationStep3FormData])

  useEffect(() => {
    if(!displayValuation && requireReview) {
      SetConveyancingValue({...conveyancingValues, valuation: "", estimated_market_value: ""});
    }
  }, [displayValuation, requireReview])

  useEffect(()=>{
    if(requireReview) {
      processStageBDocumentation(financialFormValues.new_loan_type as LoanTypeEnum, conveyancingValues.proposed_solicitor_type as SolicitorTypeEnum, requireReview, isProposedSolicitorConveyancingSameAsCurrent);
    } else {
      processDocumentsForOutgoingOwners(conveyancingValues);
    }
  },[conveyancingValues, financialFormValues, requireReview, isProposedSolicitorConveyancingSameAsCurrent, personalDetailValues.login_user.myinfo.name])


  const isSoleOwnership = useMemo(()=>{
    return applicationStep1FormData.household.incoming_owners.length === 1 && applicationStep1FormData.household.incoming_owners.every(e=>e.myinfo.uinfin === loginUser.uinfin) && !isMainApplicant;
  },[applicationStep1FormData.household.incoming_owners, isMainApplicant, loginUser.uinfin]);

  const mainApplicantStructureStatus = useMemo(() => {
    return applicationStep1FormData.household.owners.find(e=> e.myinfo.uinfin === applicationStartFormData.selected_hdb_property?.main_applicant_uinfin )?.structure_status;
  }, [applicationStep1FormData.household.owners, applicationStartFormData.selected_hdb_property?.main_applicant_uinfin])

  const firstOwnerName = useMemo(()=>{
    const foundIncoming = applicationStep1FormData.household.incoming_owners.find(e=>e.structure_order === "L1");

    if(!foundIncoming){
      console.log("STAGE B -> NO FIRST OWNER NAME");
      return ""
    }

    return foundIncoming.myinfo.name;
  },[ applicationStep1FormData ])


  const foundUser = useMemo(()=>{
    const foundIncoming = applicationStep1FormData.household.incoming_owners.find(e=>e.myinfo.uinfin === loginUser.uinfin);
    return foundIncoming;
  },[applicationStep1FormData.household.incoming_owners, loginUser.uinfin])
 
  useEffect(() => {
    if(isMainApplicant){
      navigate(`/application-coo/stage-b/consent?application_id=${applicationId}`);
    }else{
      navigate(`/application-coo/stage-b/review?application_id=${applicationId}`);
    }
    
    let timeoutId: number;
    timeoutId = window.setTimeout(() => {
      if(isLoading){
        setIsLoading(false);
      }
    }, 1000);
  
    return () => {
      clearTimeout(timeoutId);
    }
  }, [isLoading, setIsLoading, isMainApplicant, navigate])

  useEffect(() => {
    toScroll();
  }, [isLoading]);
  
  const processSameProposedOwner = useCallback(() => {
    
    let holding_type_obj = {};
    if(isSoleOwnership){
      holding_type_obj = {
        holding_type: HoldingTypeEnum.sole_ownership,
        is_holding_type_confirm: true
      }
    }

    let valuation = applicationStep3FormData.valuation;

    if(conveyancingValues.proposed_same_solicitor){
      SetConveyancingValue({...conveyancingValues, valuation:valuation, proposed: conveyancingValues.current, proposed_solicitor_type: conveyancingValues.current_solicitor_type, proposed_same_solicitor: !conveyancingValues.proposed_same_solicitor, ...holding_type_obj})
    }
    else if(!conveyancingValues.proposed_same_solicitor){
      SetConveyancingValue({...conveyancingValues, valuation:valuation, proposed: conveyancingValues.proposed, proposed_solicitor_type: conveyancingValues.current_solicitor_type, proposed_same_solicitor: !conveyancingValues.proposed_same_solicitor, ...holding_type_obj})
    }
  },[SetConveyancingValue, applicationStep3FormData.valuation, conveyancingValues, isSoleOwnership])
  
  const processOutgoingDifferentSolicitor = useCallback(() => {
    if(!conveyancingValues.outgoing_different_solicitor){
      SetConveyancingValue({...conveyancingValues, outgoing_different_solicitor: !conveyancingValues.outgoing_different_solicitor});
    }else{
      SetConveyancingValue({...conveyancingValues, outgoing_different_solicitor: !conveyancingValues.outgoing_different_solicitor, outgoing_solicitor_type: undefined, outgoing: new LegalRepresentation()});
    }
  },[SetConveyancingValue, applicationStep3FormData.valuation, conveyancingValues, isSoleOwnership])

  /**
    * when financing change, decide to clear conveyancing values use effect
    */
    // useEffect(()=>{
    // if(!isLoading){
    //   if(isMainOutgoing && !isLoginOutgoing && !!financialFormValues.new_loan_type){
    //     // resetConveyancing();
    //   }
    // }
    // },[financialFormValues.new_loan_type, isLoading])

  useEffect(()=>{
    if(!isLoading){
      let initTenancyInCommon:TenancyInCommon[] = [];
      if(applicationStep3FormData.holding_type === HoldingTypeEnum.tenancy_in_common){
        initTenancyInCommon = cloneDeep([...applicationStep3FormData.tenancy_in_common]);
      }
      else{
       initTenancyInCommon = applicationStep1FormData.household.incoming_owners?.map(e=> new TenancyInCommon({user : new Owner(e)}));
      }
        
      const foundIncoming = applicationStep1FormData.household.incoming_owners.find(e=>e.myinfo.uinfin === loginUser.uinfin);
      const foundCurrent = applicationStep1FormData.household.owners.find(e=>e.myinfo.uinfin === loginUser.uinfin);
      let structure_status = foundIncoming ? foundIncoming.structure_status : StructureStatusEnum.outgoing;
      let structure_order = foundIncoming ? foundIncoming.structure_order : "";
      let spr_obtained_date = foundIncoming ? foundIncoming.spr_obtained_date : "";
      let spouse_id_type = foundIncoming ? foundIncoming.spouse_id_type : "";
      let spouse = foundIncoming ? foundIncoming.spouse : "";
      //? Get application_user info by getting from either myinfo data depends on whether login user allow myinfo, else use login user info when user login.
      let login_user = new Owner({spr_obtained_date: spr_obtained_date, spouse_id_type: spouse_id_type, spouse: spouse, structure_status:structure_status, structure_order: structure_order , myinfo : new MyInfo(retrieveFromMyInfo ? myInfoData : foundIncoming?.myinfo ?? foundCurrent?.myinfo)});

      SetFinancialFormValue(applicationStep2FormData)//DONE init financial
      //SET INIT VALUE
      let is_holding_type_confirm = applicationStep3FormData.is_holding_type_confirm; //Only allow is holding_type confirm when there is value for holding_type and when only holding type is sole ownership and joint tenancy
      let proposed_same_solicitor = applicationStep3FormData.proposed_same_solicitor ?? false;
      let valuation = applicationStep3FormData.valuation;
      let estimated_market_value = applicationStep3FormData.estimated_market_value;;
      SetConveyancingValue({...conveyancingValues,valuation,estimated_market_value, is_holding_type_confirm, proposed_same_solicitor, proposed_solicitor_type:applicationStep3FormData.proposed_solicitor_type, proposed:applicationStep3FormData.proposed, financing_info:applicationStep3FormData, holding_type: applicationStep3FormData.holding_type, current: {...applicationStep3FormData.current}, current_solicitor_type: applicationStep3FormData.current_solicitor_type, tenancy_in_common:initTenancyInCommon })//DONE
      const personalDetail = {login_user};
      if(!retrieveFromMyInfo){
          personalDetail.login_user.myinfo.email = "";
          personalDetail.login_user.myinfo.mobile_no = "";
      }
     
      SetPersonalDetailValue({login_user}); //DONE
    }
  },[isLoading,loginUser, applicationStep3FormData, applicationStep2FormData])

  // To check is DOB matching.
  useEffect(()=>{
    if(foundUser && personalDetailValues.login_user.myinfo.dob !== ""){
      setIsDobMatch(foundUser.myinfo.dob === personalDetailValues.login_user.myinfo.dob);
    }
  },[applicationStep1FormData.household.incoming_owners, foundUser, loginUser.uinfin, personalDetailValues.login_user.myinfo.dob])

  // To check is marital status matching.
  useEffect(()=>{
    if(foundUser && personalDetailValues.login_user.myinfo.marital_status){
      setIsMaritalStatusMatch(foundUser.myinfo.marital_status === personalDetailValues.login_user.myinfo.marital_status);
    }
  },[applicationStep1FormData.household.incoming_owners, foundUser, loginUser.uinfin, personalDetailValues.login_user.myinfo.marital_status])

  // Remove the alert when the spouse field changes, check for matching id is done by handleSpouseIdBlur
  useEffect(()=>{
    setIsSpouseIdMatch(true);
  },[personalDetailValues.login_user.spouse])

  //to remove uploaded document uploaded if the document prompt disappear
  useEffect(() => {
      const promptedDocumentsLabels = documentList.map(item => item.label);
      const filteredDocuments = cloneDeep(documentationValues.file_items).filter(item => item.label && promptedDocumentsLabels.includes(item.label));
      SetDocumentationValue({file_items: filteredDocuments});
  }, [documentList])

  const isChanged = useMemo(() => {
        let isChanged = false;
        const validatingMyInfoKeys: string[] = ["dob", "marital_status", "name", "residential_status", "uinfin"];
        for(const key of Object.keys(personalDetailValues.login_user.myinfo)){
            const castedKey = key as keyof MyInfo;
            if(validatingMyInfoKeys.includes(castedKey) 
              && mainApplicantFilledData.my_info 
              && personalDetailValues.login_user.myinfo[castedKey] !== mainApplicantFilledData.my_info[castedKey] )
            {
              isChanged = true;
              break;
            }
        }

        if(personalDetailValues.login_user.is_related !== mainApplicantFilledData.is_related){
            isChanged = true;
        }

        if(personalDetailValues.login_user.relationship_with_owner !== mainApplicantFilledData.relationship_with_owner){
          isChanged = true;
      }

        return isChanged;
  }, [personalDetailValues, mainApplicantFilledData])

  const checkMopStatus = useCallback(async (value: string) => {
    try {
      const response = await PolymerAxios("", singpassToken)
        .get(`${API_MOPCheck}/${value}`)
        .then((res) => res.data);
      console.log('MOP response:', response);
      setMopResult(response?.satisfy_mop);
    } catch (error) {
      console.log(error);
    }
  }, [singpassToken]);

  useEffect(() => {
      checkMopStatus(applicationStartFormData.selected_hdb_property?.hdb_ref ?? "");
  }, [])

  useEffect(() => {
    const loginDataByMainApplicant = applicationStep1FormData.household.incoming_owners.find(item => item.myinfo.uinfin === loginUser.uinfin);
   
    if(loginDataByMainApplicant){
      setMainApplicantFilledData({my_info: loginDataByMainApplicant.myinfo, is_related: loginDataByMainApplicant.is_related, relationship_with_owner: loginDataByMainApplicant.relationship_with_owner})
    }

  }, [applicationStep1FormData, loginUser])
  useEffect(()=>{
    setAdditionalData({isLoginRetaining, isLoginOutgoing, isMainRetaining, isMainOutgoing});
    SetFinancialAdditionData({isLoginRetaining, isLoginOutgoing, isMainRetaining, isMainOutgoing});
    SetConveyancingAdditionData({isLoginRetaining, isLoginOutgoing, isMainRetaining, isMainOutgoing, isRemission, isProposedDirectConveyancing, isCurrentDirectConveyancing});
    SetPersonalDetailAdditionData({isLoginRetaining, isLoginOutgoing, isMainRetaining, isMainOutgoing});
  },[isLoginRetaining, isLoginOutgoing, isMainRetaining, isMainOutgoing, isRemission, setAdditionalData, SetFinancialAdditionData, SetConveyancingAdditionData, SetPersonalDetailAdditionData, isProposedDirectConveyancing, isCurrentDirectConveyancing])

  const isDocumentRequested = useMemo(()=>{
    return documentList.length > 0; 
  },[documentList.length])


  const isBtnValid = useMemo(()=>{
    let documentation_valid = true;
    //When only isLoginOutgoing, under conveyancing, user required to upload documentation, so need to check the file items size to determine whether there are file selected;
    const validDocumentationValues = documentationValues.file_items.length > 0 && documentationValues.file_items.every(item => item.file_id !== "");
    //NOTE: when is additional role created this application, no need document check (TO MONITOR)
    if(isDocumentRequested){
      documentation_valid = validDocumentationValues;
    }
    if(config.isLocalhost){
      console.warn("LOCALHOST TO MAKE DOCUMENT TRUE");
      documentation_valid = true;
    }
    let isPersonalDetailValid = personalDetailValid;
    if(!isLoginRetaining && !isLoginIncoming){
      /**
       * NOTE: when owner is outgoing, will no display the personal details section and only check email and mobile no and marital status.
       * */
      isPersonalDetailValid = personalDetailErrors?.login_user?.email?.isValid && personalDetailErrors?.login_user?.mobile_no?.isValid && (isLoginOutgoing ? personalDetailErrors?.login_user?.marital_status?.isValid : true);
    }
    console.log("DEBUG --conveyancingValid",conveyancingValid)
    console.log("DEBUG ----financialFormValid",financialFormValid)
    console.log("DEBUG ------isPersonalDetailValid",isPersonalDetailValid)
    console.log("DEBUG --------formValid",formValid)
    console.log("DEBUG ----------documentation_valid",documentation_valid)
    console.log("DEBUG ------------isHLEApprovalPass",isHLEApprovalPass)

    //requireReview = first consent owner to fill up proposed info, if no need to fill up only check for document valid
    const requiredReviewItemsValid = requireReview ? (conveyancingValid && financialFormValid && documentation_valid) : documentation_valid;
    const outgoingDifferentSolicitorValid = conveyancingValues.outgoing_different_solicitor ? (conveyancingValid && documentation_valid) : true;
    return requiredReviewItemsValid && outgoingDifferentSolicitorValid && isPersonalDetailValid && formValid && isHLEApprovalPass !== false;
  },[documentationValues.file_items, isDocumentRequested, isMainApplicantCreateApplication, personalDetailValid, isLoginRetaining, isLoginIncoming, isLoginOutgoing, conveyancingValid, financialFormValid, formValid, isHLEApprovalPass, personalDetailErrors?.login_user?.email?.isValid, personalDetailErrors?.login_user?.mobile_no?.isValid, personalDetailErrors?.login_user?.marital_status?.isValid, requireReview, conveyancingValues])

  const getOwnersAndOccupiersForCheck = useCallback(() => {
    const allOwners = applicationStep1FormData.household.incoming_owners.concat(applicationStep1FormData.household.owners);
    const owners: Owner[] = [];
    const allowBypass35YearsOldCheck = checkNeedBypass35YearsOld(applicationStep1FormData.household, applicationStep1FormData.reason);
    for(const owner of allOwners){
      if(!owners.some(item => PolymerCrypto.decryption(item.myinfo.uinfin) === owner.myinfo.uinfin)){
          let name = owner.myinfo.name;
          let dob = owner.myinfo.dob;
          let residentialStatus = owner.myinfo.residential_status;
          let maritalStatus = owner.myinfo.marital_status;
          let sex = owner.myinfo.sex;
          let nationality = owner.myinfo.nationality;
          let race = owner.myinfo.race;
          let spouse = owner.spouse;
          let spouseIdType = owner.spouse_id_type;
          let relationshipWithOwner = owner.relationship_with_owner;
          const isProposed = owner.structure_status === StructureStatusEnum.incoming || owner.structure_status === StructureStatusEnum.retaining;
          if(allowBypass35YearsOldCheck && !relationshipWithOwner && isProposed){
            relationshipWithOwner = "SO";//bypass backend check
          }

          if(owner.myinfo.uinfin === personalDetailValues.login_user.myinfo.uinfin){
            name = personalDetailValues.login_user.myinfo.name;
            dob = personalDetailValues.login_user.myinfo.dob;
            residentialStatus = personalDetailValues.login_user.myinfo.residential_status;
            maritalStatus = personalDetailValues.login_user.myinfo.marital_status;
            sex = personalDetailValues.login_user.myinfo.sex;
            nationality = personalDetailValues.login_user.myinfo.nationality;
            race = personalDetailValues.login_user.myinfo.race;
            spouse = personalDetailValues.login_user.spouse;
            spouseIdType = personalDetailValues.login_user.spouse_id_type;            
          }
          owners.push(new Owner({
            structure_status: owner.structure_status ? owner.structure_status : StructureStatusEnum.outgoing,
            own_property: owner.own_property,
            children_care_and_control: owner.children_care_and_control,
            relationship_with_owner: relationshipWithOwner,
            myinfo: new MyInfo({
              uinfin: PolymerCrypto.encryption(owner.myinfo.uinfin),
              name: name,
              dob: dob,
              residential_status: residentialStatus,
              marital_status: maritalStatus? maritalStatus : MaritalStatusEnum.single,
              sex: sex,
              nationality: nationality,
              race: race
            }),
            spouse: PolymerCrypto.encryption(spouse),
            spouse_id_type: spouseIdType
          }))
      }
    }    

    const allOccupiers = applicationStep1FormData.household.incoming_occupiers.concat(applicationStep1FormData.household.occupiers);
    const occupiers: Occupier[] = [];
    for(const occupier of allOccupiers){
      if(!occupiers.some(item => PolymerCrypto.decryption(item.myinfo.uinfin) === occupier.myinfo.uinfin)){
        let name = occupier.myinfo.name;
        let dob = occupier.myinfo.dob;
        let residentialStatus = occupier.myinfo.residential_status;
        let maritalStatus = occupier.myinfo.marital_status;
        let sex = occupier.myinfo.sex;
        let nationality = occupier.myinfo.nationality;
        let race = occupier.myinfo.race;
        let spouse = occupier.spouse;
        let spouseIdType = occupier.spouse_id_type;

        if(occupier.myinfo.uinfin === personalDetailValues.login_user.myinfo.uinfin){
          name = personalDetailValues.login_user.myinfo.name;
          dob = personalDetailValues.login_user.myinfo.dob;
          residentialStatus = personalDetailValues.login_user.myinfo.residential_status;
          maritalStatus = personalDetailValues.login_user.myinfo.marital_status;
          sex = personalDetailValues.login_user.myinfo.sex;
          nationality = personalDetailValues.login_user.myinfo.nationality;
          race = personalDetailValues.login_user.myinfo.race;
          spouse = personalDetailValues.login_user.spouse;
          spouseIdType = personalDetailValues.login_user.spouse_id_type;            
        }
        
        occupiers.push(new Occupier({
          structure_status: occupier.structure_status ? occupier.structure_status : StructureStatusEnum.outgoing,
          own_property: occupier.own_property,
          relationship_with_owner: occupier.relationship_with_owner,
          myinfo: new MyInfo({
            uinfin: PolymerCrypto.encryption(occupier.myinfo.uinfin),
            name: name,
            dob: dob,
            residential_status: residentialStatus,
            marital_status: maritalStatus? maritalStatus : MaritalStatusEnum.single,
            sex: sex,
            nationality: nationality,
            race: race
          }),
          spouse: PolymerCrypto.encryption(spouse),
          spouse_id_type: spouseIdType
        }))
      }
    }

    return {occupiers: occupiers, owners: owners}
  },[applicationStep1FormData, personalDetailValues])

  const hasExecutorAdministrator = useMemo(()=>{
    return applicationStartFormData?.selected_hdb_property?.additional_roles.some(e=>{
      const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
      return roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator
    })
  },[applicationStartFormData?.selected_hdb_property?.additional_roles])

  const isToIncludeValuation = useMemo(()=>{
    const isProposedHDBLoan = applicationStep2FormData.new_loan_type === LoanTypeEnum.hdb_loan || financialFormValues.new_loan_type === LoanTypeEnum.hdb_loan;
    const isResale = checkIsFlatResale(applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code!);
    const isValuationHDB = applicationStep3FormData.valuation === StampDutyValuationEnum.hdb || conveyancingValues.valuation === StampDutyValuationEnum.hdb;
    
    console.log("DEBUG -- isValuationHDB", isValuationHDB, isResale, isProposedHDBLoan);

    if(isValuationHDB || (isResale && isProposedHDBLoan)){
      return true;
    }
    return false
  },[applicationStep2FormData.new_loan_type, applicationStep3FormData.valuation, applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code, conveyancingValues.valuation, financialFormValues.new_loan_type]);

  useEffect(() => {
    setForceErrors({...forceErrors, financing: false});
  }, [financialFormValues])

  useEffect(() => {
    setForceErrors({...forceErrors, conveyancing: false});
  }, [conveyancingValues])

  useEffect(() => {
    setForceErrors({...forceErrors, personalDetails: false});
  }, [personalDetailValues])

  useEffect(() => {
    setForceErrors({...forceErrors, declaration: false});
  }, [values.input_verified])

  useEffect(() => {
    setForceErrors({...forceErrors, documents: false});
  }, [documentationValues])

  const sendFormValidationLogs = useCallback(async() => {
    const validationResult = {
        uinfin: loginUser?.uinfin,
        applicationUuid: applicationId,
        hdbRef: applicationStartFormData?.selected_hdb_property?.hdb_ref,
        isMainApplicantCreateApplication: isMainApplicantCreateApplication,
        requireReview: requireReview,
        declarationCheckbox: values.input_verified,
        financial: {
           values: financialFormValues,
           errors: financialFormErrors
        },
        conveyancing: {
           values: conveyancingValues,
           errors: conveyancingErrors
        },
        documentationValues: {
           promptedDocuments: documentList,
           uploadedDocuments: documentationValues.file_items
        },
        personalDetails: {
           values: personalDetailValues,
           errors: personalDetailErrors
        }
    }
    await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
      applicationUuid: loginUser?.uinfin,
      message: JSON.stringify(validationResult)
    });
  }, [financialFormValues, financialFormErrors, conveyancingValues, conveyancingErrors, documentationValues, documentList , personalDetailValues, personalDetailErrors, applicationId, loginUser?.uinfin, applicationStartFormData, requireReview, isMainApplicantCreateApplication, values.input_verified])

  const applicantGiveConsent = useCallback(async() =>{
    if(!isBtnValid) {
      setForceErrors({financing: true, conveyancing: true, personalDetails: true, documents: true, declaration: true});
      sendFormValidationLogs();
      return;
    }
    setIsSubmitting(true);
    
    try{
      // Do frontend check
      const uinfin = personalDetailValues?.login_user?.myinfo?.uinfin?.length > 0 ? personalDetailValues?.login_user?.myinfo?.uinfin : loginUser?.uinfin;
      const isOwner = applicationStep1FormData.household.owners.some((owner) => owner.myinfo.uinfin === uinfin);
      const isOccupier = applicationStep1FormData.household.occupiers.some((occupier) => occupier.myinfo.uinfin === uinfin);
      const isProposedOwner = applicationStep1FormData.household.incoming_owners.some((owner) => owner.myinfo.uinfin === uinfin);
      const isProposedOccupier = applicationStep1FormData.household.incoming_occupiers.some((occupier) => occupier.myinfo.uinfin === uinfin);
      const isAdditionalRole = applicationStartFormData?.selected_hdb_property?.additional_roles?.some(item => item.uinfin === uinfin);
      if(!isOwner && !isOccupier && !isProposedOwner && !isProposedOccupier && !isAdditionalRole){
        setIsEligible(false);
        console.log("login user UINFIN not found.");
        setIneligibleMessage("Uinfin of logged-in user not found in current and proposed household.")
        setIsSubmitting(false);
        return;
      }
      const household = cloneDeep(applicationStep1FormData.household);
      if(isProposedOwner || isProposedOccupier){
        const personsArray = isProposedOwner ? household.incoming_owners : household.incoming_occupiers;
        const personIndex = personsArray.findIndex(item => item.myinfo.uinfin === personalDetailValues.login_user.myinfo.uinfin);
        if(personIndex !== -1){
          personsArray[personIndex] = personalDetailValues.login_user;
        }
     }

      let applicationForm = new ApplicationStep1({ reason: applicationStep1FormData.reason, household: household });
      const step1SchemeCheckingEligibilityResult = await step1SchemeCheckingEligibility(applicationForm, loginUser?.uinfin ?? "", applicationStartFormData.selected_hdb_property?.flat_type, mopResult, currentHoldingType, hasExecutorAdministrator);

      try {
        if (step1SchemeCheckingEligibilityResult?.debug && step1SchemeCheckingEligibilityResult?.debug !== "") {
          await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
            applicationUuid: loginUser?.uinfin,
            message: `FE STAGE B DEBUG LOG [NOT ELIGIBLE] ---  ${step1SchemeCheckingEligibilityResult.debug} [------------------- STAGE B household ----------] ${JSON.stringify(household)}`
          });
        }
        else{
          await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
            applicationUuid: applicationId,
            message: `FE STAGE B DEBUG LOG [ELIGIBLE] --- ${step1SchemeCheckingEligibilityResult.debug}`
          });
        }
      } catch (error) {
        console.log("Submit eligibility error log to backend failed.");
      }


      if (!step1SchemeCheckingEligibilityResult.eligible) {
        console.log(step1SchemeCheckingEligibilityResult.message)
        setIsEligible(false);
        setIneligibleMessage(step1SchemeCheckingEligibilityResult.message);
        setIsSubmitting(false);
        return;
      }

      const findCor = ChangeOwnershipReasonCode.find(item => item.change_ownership_reason_value === applicationStep1FormData.reason.change_ownership_reason);
      const corCode = findCor?.code ?? applicationStep1FormData.reason.change_ownership_reason;
      const ownersAndOccupiers = getOwnersAndOccupiersForCheck();
      const proposedOwners = ownersAndOccupiers.owners.filter(item => item.structure_status !== StructureStatusEnum.outgoing);
      const proposedOccupiers = ownersAndOccupiers.occupiers.filter(item => item.structure_status !== StructureStatusEnum.outgoing);
      // Spouse check
      const spouseCheckResult = spouseCheck([...proposedOwners, ...proposedOccupiers]);
      if (!spouseCheckResult.eligible) {
        console.log("spouse check failed")
        setIsEligible(false);
        setIneligibleMessage(spouseCheckResult.message);
        setIsSubmitting(false);
        return;
      }
      
      const eligibilityObj = new Eligibility({uinfin: PolymerCrypto.encryption(loginUser?.uinfin), change_ownership_reason: corCode, owners: ownersAndOccupiers.owners, occupiers: ownersAndOccupiers.occupiers, hdb_ref: applicationStartFormData?.selected_hdb_property?.hdb_ref});
      console.warn("DEBUG -- eligibilityObj",eligibilityObj);
      console.warn("DEBUG -- Bypass ownersAndOccupiers STAGE B", applicationStep1FormData ,ownersAndOccupiers,eligibilityObj);

      const eligibilityCheckResult = await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_CheckEligibility, eligibilityObj);
      if(!eligibilityCheckResult.data.eligible){
        setIsEligible(eligibilityCheckResult.data.eligible);
        setIneligibleMessage(eligibilityCheckResult?.data?.message);
        setIsSubmitting(false);
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
          applicationUuid: loginUser?.uinfin,
          message: `FE STAGE B DEBUG LOG [NOT ELIGIBLE] [Backend] ---  ${eligibilityCheckResult?.data?.message} [------------------- STAGE B household ----------] ${JSON.stringify(household)}`
        });
        return;
      }
      //NOTE BYPASS: Bypass due to divorce logic issue. Refer to Ticket https://gitlab02.decision-science.agency/hdb/hdb-change-in-flat-ownership-service/-/issues/124
      // console.warn("DEBUG -- Bypass Stage B give consent api",eligibilityCheckResult.data.eligible);
      setIsEligible(true);

      
      const consentObj = new CooGiveConsent();
      if(applicationId){
        consentObj.setApplicationId(applicationId);
      }
      consentObj.setGiveConsent(true);
      consentObj.setOwner(personalDetailValues);
      const submitFinancing : SubmitFinancing = {
          ...financialFormValues,
          current_loan_amount: Number(financialFormValues.current_loan_amount),
          current_loan_type: financialFormValues.current_loan_type?.toString() ?? "",
          new_loan_type: financialFormValues.new_loan_type?.toString() ?? "",
      }
      consentObj.setFinancingInfo(new SubmitFinancing(submitFinancing))
      consentObj.setConveyancingStageB(conveyancingValues, mainApplicantStructureStatus );
      consentObj.setStageBDocuments(documentationValues.file_items);
      consentObj.setMapRelationshipWithOwner(applicationStep1FormData, loginUser.uinfin);
      
      const submittingValues = {...consentObj.getGiveConsentJSON(), application_id: consentObj.application_uuid};

      if(documentationValues?.file_items.length > 0){
        
        let documentations = documentationValues.file_items.map(e=>{
          return {
            "document_code" : e.code,
            "document_type" : e.file_content.document_type,
            "required_option_checked" : true,
            "key" : e.key,
            "uuid" : e.file_id.toString(),
            "label" : e.label,
            "file_size": e.file?.size || 0
          }
        })
        
        const documentSavePayload = {
          application_uuid : applicationId,
          documents: [...documentations]
        }
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_DocumentSave, documentSavePayload).then(res=>{
          console.log("document save api", res);
        }).catch(e=>{
          console.log("document save api catch", e);
        });
      }

      const transactionTypes: string[] = [];
      if(!bypassPayments.admin) {
         transactionTypes.push("admin");
      }

      if(!bypassPayments.valuation && isToIncludeValuation) {
        transactionTypes.push("valuation");
      }

      await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_GiveConsent,{...submittingValues, transaction_types: transactionTypes}).then(res=>{
        console.log("/application-coo/stage-b/consent response----->",res);
        if(res.data.status === 200){
          navigate(`/application-coo/stage-b/consent?application_id=${applicationId}`)
        }
      }).catch(e=>{
        console.log("catch",e)
      }).finally(()=>{
        setIsSubmitting(false);
      })

      // Update override eligibility value
      const overrideEligibilityCheck = new EligibilityOverride({ application_uuid: application_id });

      if (conveyancingValues.proposed_solicitor_type && bypassSolicitors.proposed) {
        overrideEligibilityCheck.proposed_household_solicitor = EligibilityCheck.BYPASS;
      }

      await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_OverrideEligibilityCheck, overrideEligibilityCheck);

      const eligibilityCheck = false;
      if( eligibilityCheck ) {
        //NOTE BYPASS
        setIsEligible(true);
      }
    }catch(error){
      setIsEligible(false);
      setIneligibleMessage("Please try again later.")
      setIsSubmitting(false);
      console.log("/application/checkEligibility API failed", error);
    }
  },[applicationId, applicationStep1FormData, conveyancingValues, mainApplicantStructureStatus, documentationValues.file_items, financialFormValues, getOwnersAndOccupiersForCheck, loginUser?.uinfin, navigate, personalDetailValues, singpassToken, applicationStartFormData, mopResult, hasExecutorAdministrator, applicationStartFormData, bypassSolicitors, bypassPayments, isToIncludeValuation, isBtnValid, sendFormValidationLogs])

  const onBindMyInfoToHolding = useCallback((myInfoData:MyInfo) => {
    
      const foundIncoming = applicationStep1FormData.household.incoming_owners.find(e=>e.myinfo.uinfin === loginUser.uinfin);
      let structure_status = foundIncoming ? foundIncoming.structure_status : StructureStatusEnum.outgoing;
      let structure_order = foundIncoming ? foundIncoming.structure_order : "";
      
       //NOTE: Bind only all myinfo but not mobile_no and email, because mobile_no and email will be separate retrieve.
      //NOTE: when sex is unknown, do not need to bind;
      const sex = myInfoData.sex === SexEnum.unknown ? "" : myInfoData.sex;
      const ethnicCode = convertRaceToEthnicCode(myInfoData.race);
      
      let login_user = new Owner({structure_status:structure_status, structure_order: structure_order, myinfo : new MyInfo({...myInfoData, uinfin: PolymerCrypto.decryption(myInfoData.uinfin), mobile_no: PolymerCrypto.decryption(myInfoData.mobile_no), email: PolymerCrypto.decryption(myInfoData.email) , race:ethnicCode, sex:sex})});
      SetPersonalDetailValue({login_user}); //DONE
    
  },[SetPersonalDetailValue, applicationStep1FormData.household.incoming_owners, loginUser.uinfin]);
  
  const onUnBindMyInfoToHolding = useCallback(() => {
    const foundIncoming = applicationStep1FormData.household.incoming_owners.find(e=>e.myinfo.uinfin === loginUser.uinfin);
    let structure_status = foundIncoming ? foundIncoming.structure_status : StructureStatusEnum.outgoing;
    let structure_order = foundIncoming ? foundIncoming.structure_order : "";
    
    let login_user = new Owner({structure_status:structure_status, structure_order: structure_order, myinfo : new MyInfo({name: foundIncoming?.myinfo.name})});
    SetPersonalDetailValue({login_user}); //DONE
    
  },[SetPersonalDetailValue, applicationStep1FormData.household.incoming_owners, loginUser]);

  const handleBackNavigation = useCallback(() => {
    navigate(`/application-coo?application_id=${applicationId}`)
  },[applicationId, navigate])

  const handleSpouseIdFieldBlur = () => {
    if(foundUser && personalDetailValues.login_user.spouse){
      setIsSpouseIdMatch(foundUser.spouse === personalDetailValues.login_user.spouse);
    }
  }


  const setDeclarationCheckboxValue = useCallback(() => {
    setFormValue({ ...values, input_verified: !values.input_verified })
  },[setFormValue, values])

  useEffect(() => {
    if (customWindow.wogaaCustom) {
      customWindow.wogaaCustom.startTransactionalService(stageBTrackingId);
    }
  }, []);

  useEffect(() => {
    const triggeredError = Object.values(forceErrors).filter(item => item === true).length === 5;
    if(triggeredError) {
      setTimeout(() => {
        const errorElements = document.getElementsByClassName("polymer-alert__container-danger");
        const inputErrorElements = document.getElementsByClassName("polymer-fields-error-message");
        const combinedElements = Array.from(errorElements).concat(Array.from(inputErrorElements));
        if(combinedElements.length === 0) {
          return;
        }

        const uppermostElement = Array.from(combinedElements).reduce((uppermost, current) => {
          return current.getBoundingClientRect().top < uppermost.getBoundingClientRect().top
              ? current
              : uppermost;
        });
        
        if(uppermostElement) {
          uppermostElement.scrollIntoView({behavior: "smooth", block: "center"})
        }
      }, 500)
    }
}, [forceErrors])

  if (isLoading) {
    return <div className='polymer-start-application__loading'>Checking...</div>
  }
  return (

    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper'>

        <div>
          <TextSubheader
            subheaderMain="Stage B: Gather Consent"
            subheaderSub={applicationStartFormData.selected_hdb_property?.address}
            paddingLeftRight={42}
          />
        </div>
        <div className='d-flex justify-content-center' style={{marginTop:"62px"}}>
          <SectionCard
            disabled={isSubmitting}
            required={false}
            className='flex-fill'
            titleChildren={
              <P2TextDescription title={"Review and Endorse"} />
            }
            contentChildren={
              <div>
                <div className='px-4 pb-5'>
                  {/* DONE WHEN MAIN is OUTgoing, L1 is Incoming */}
                  <ReviewHouseholdStructureTable enableMasking={isLoginOutgoing} isMainOutgoing={requireReview} conveyancingValues={conveyancingValues} financialFormValues={financialFormValues}/>
                </div>
                <Separator variant='solid'/>
                  {/* DONE WHEN MAIN is OUTgoing, L1 is Incoming */}
                <ReviewEligibility reasonCode={ChangeOwnershipReasonCode.find(e=>e.change_ownership_reason_value === applicationStep1FormData.reason.change_ownership_reason)?.code}/>
                <Separator variant='solid'/> 
                
                  {/* DONE WHEN MAIN is OUTgoing, L1 is Incoming */}
                <ReviewFinancing forceError={forceErrors.financing} conveyancing_values={conveyancingValues} setConveyancingValue={SetConveyancingValue} isLoginOutgoing={isLoginOutgoing} isMainOutgoing={requireReview} financial_values={financialFormValues} personal_values={personalDetailValues} loan_type={financialFormValues.new_loan_type as LoanTypeEnum} setFormValue={SetFinancialFormValue} setHLeApprovalPass={setIsHLEApprovalPass} isMainApplicantCreateApplication={isMainApplicantCreateApplication}/>
                <Separator variant='solid'/>
                
                <ReviewConveyancing forceError={forceErrors.conveyancing} forceErrorDocuments={forceErrors.documents} documentList={documentList} processSameProposedOwner={processSameProposedOwner} updateLastWillIsChecked={updateLastWillIsChecked} financial_values={financialFormValues} isDocumentRequested={isDocumentRequested} displayValuation={displayValuation} isSoleOwnership={isSoleOwnership} isLoginOutgoing={isLoginOutgoing} isMainOutgoing={requireReview} conveyancing_values={conveyancingValues} personal_values={personalDetailValues} documentation_values={documentationValues} setFormValue={SetConveyancingValue} errors={conveyancingErrors} SetDocumentationValue={SetDocumentationValue} isCurrentDirectConveyancing={isCurrentDirectConveyancing} isProposedDirectConveyancing={isProposedDirectConveyancing} applicationStep1FormData={applicationStep1FormData} isMainApplicantCreateApplication={isMainApplicantCreateApplication} differentOutgoingOwnerSolicitorNotSelected={differentOutgoingOwnerSolicitorNotSelected} processOutgoingDifferentSolicitor={processOutgoingDifferentSolicitor}/>

                {(isLoginRetaining || isLoginIncoming) && <>
                  <Separator variant='solid'/> 
                  <ReviewPersonalDetails forceError={forceErrors.personalDetails} isLoginRetainingOrOutgoing={isLoginRetaining || isLoginOutgoing} onBindMyInfo={onBindMyInfoToHolding} onUnBindMyInfo={onUnBindMyInfoToHolding} values={values} personal_values={personalDetailValues} retrieveFromMyInfo={!!retrieveFromMyInfo} setFormValue={SetPersonalDetailValue} errors={personalDetailErrors} firstOwnerName={firstOwnerName} isDobMatch={isDobMatch} isMaritalStatusMatch={isMaritalStatusMatch} isSpouseIdMatch={isSpouseIdMatch} handleSpouseIdFieldBlur={handleSpouseIdFieldBlur} isChanged={isChanged}/>
                </>}
                
                <Separator variant='solid'/> 
                <Declaration forceError={forceErrors.declaration} checkboxValue={values.input_verified} setCheckboxValue={setDeclarationCheckboxValue}/>
                <ContactDetails forceError={forceErrors.personalDetails} personal_values={personalDetailValues} setFormValue={SetPersonalDetailValue} errors={personalDetailErrors} isLoginOutgoing={isLoginOutgoing}/>
              </div>

            }
          />
        </div>
        <Separator style={{margin:"32px 42px"}}/>
        <div className='polymer-shared-alert-container'>
            {isEligible === false && <div style={{ marginTop: 24, marginBottom: 24 }}>
              <P2Alert variant={"warning"} text={ineligibleMessage}></P2Alert>
            </div>}
        </div>

        <div className='polymer-application-coo__card-button'>
          <P2ButtonGroup>
            <P2Button variant={"outline-primary"} onClick={handleBackNavigation}>Cancel</P2Button>
            <P2Button variant={"outline-primary"} onClick={handleBackNavigation}>Back</P2Button>
          
            <P2Button variant={"primary-1"} onClick={applicantGiveConsent} disabled={isSubmitting}>{"Give consent"}</P2Button>
          </P2ButtonGroup>
        </div>
      </div>
    </ApplicationCooLayout>
  )
}

export default OthersReview
